export default function DocumentsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('documents');
}

DocumentsConfiguration.$inject = ['$translatePartialLoaderProvider'];
